import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import TagManager from "react-gtm-module";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
// import { BrowserRouter } from "react-router-dom";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import ReactGA from "react-ga";

import authReducer from "./store/reducers/auth";
// import withTracker from "./hoc/withTracker/withTracker";
// import { Route } from "react-router";

// const tagManagerArgs = {
//   gtmId: "GTM-PK4CJK8",
// };

// TagManager.initialize(tagManagerArgs);

// const composeEnhancers =
//   process.env.NODE_ENV === "development"
//     ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
//     : null || compose;

const store = createStore(authReducer, compose(applyMiddleware(thunk)));

const history = createBrowserHistory();
ReactGA.initialize("UA-134495352-2");
history.listen((location) => {
  ReactGA.pageview(location.pathname + location.search);
});

// const AppComponent = withTracker(<App />, {});

// ReactGA.initialize("G-R9HDP880XQ");

// ReactGA.pageview(window.location.pathname + window.location.search);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
